import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  RELEASE_UPDATE_CATEGORIES,
  RELEASE_UPDATE_CATEGORY_LABELS,
  emptyReleaseUpdateItem,
  type ReleaseUpdateCategory,
  type ReleaseUpdateItemForm,
} from '../../../../../../shared/models/release-notes.models';
import { AdminButtonComponent } from '../../../../../../shared/admin';
import { ReleaseImageUploaderComponent } from '../release-image-uploader/release-image-uploader.component';

@Component({
  selector: 'app-release-update-card',
  standalone: true,
  imports: [FormsModule, DragDropModule, AdminButtonComponent, ReleaseImageUploaderComponent],
  templateUrl: './release-update-card.component.html',
  styleUrl: './release-update-card.component.scss',
})
export class ReleaseUpdateCardComponent {
  readonly item = input.required<ReleaseUpdateItemForm>();
  readonly index = input.required<number>();
  readonly itemChange = output<ReleaseUpdateItemForm>();
  readonly remove = output<void>();

  readonly categories = RELEASE_UPDATE_CATEGORIES;
  readonly categoryLabels = RELEASE_UPDATE_CATEGORY_LABELS;

  update(patch: Partial<ReleaseUpdateItemForm>): void {
    this.itemChange.emit({ ...this.item(), ...patch });
  }

  onDescriptionInput(event: Event): void {
    const el = event.target as HTMLElement;
    this.update({ description: el.innerHTML });
  }

  format(command: string): void {
    document.execCommand(command, false);
  }
}

@Component({
  selector: 'app-release-update-list',
  standalone: true,
  imports: [DragDropModule, AdminButtonComponent, ReleaseUpdateCardComponent],
  templateUrl: './release-update-list.component.html',
  styleUrl: './release-update-card.component.scss',
})
export class ReleaseUpdateListComponent {
  readonly items = input.required<ReleaseUpdateItemForm[]>();
  readonly itemsChange = output<ReleaseUpdateItemForm[]>();

  addUpdate(): void {
    const next = [...this.items(), emptyReleaseUpdateItem(this.items().length)];
    this.itemsChange.emit(next);
  }

  updateAt(index: number, item: ReleaseUpdateItemForm): void {
    const next = [...this.items()];
    next[index] = item;
    this.itemsChange.emit(next);
  }

  removeAt(index: number): void {
    const next = this.items().filter((_, i) => i !== index);
    this.itemsChange.emit(next);
  }

  onReorder(event: CdkDragDrop<ReleaseUpdateItemForm[]>): void {
    const next = [...this.items()];
    moveItemInArray(next, event.previousIndex, event.currentIndex);
    this.itemsChange.emit(next.map((item, i) => ({ ...item, displayOrder: i })));
  }
}
